export default __webpack_public_path__ + "static/media/next-clicked.a0e64f6e.svg";